import "../styles/AdminInterface.css"
/* import "../styles/App.css"
 */import React, { useState, useEffect } from 'react'
import BackendAPI from "../API/BackendAPI"
import IconButton from '@mui/material/IconButton';

import { useHistory } from 'react-router-dom';
import { Checkbox,ListItemText,TextField, FormControl,InputLabel,Button, Divider, Typography, TableContainer, TableHead, TableRow, Paper, TableBody, Table, TableCell, Select,Menu, MenuItem, Dialog,DialogActions,DialogContent,DialogContentText,DialogTitle } from "@material-ui/core"
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import Popup from "../components/Popup"
import Sidebar from "../components/Sidebar"
import cookie from 'react-cookies'


const AdminEtudiants = () => {
  // console.log("admin")
  const history = useHistory()


  const user = cookie.load("user")
  // console.log(user)
  const handleDisconnect = () => {
    // console.log("handleDisconnect")
    cookie.save('user', "disconnected", {
      path: '/',
      maxAge: 60 * 60 * 1.5, //sec
    })
    history.push('/login');
  }


  if (user === null || user === undefined || user == "disconnected") history.push("/login");
  if (user !== null && user !== undefined && user.username !== undefined && !user.username.toUpperCase().includes("ADMIN")) handleDisconnect()


  // const [actualiser,setActualiser]=useState(true)
  
  const [popupText,setPopupText]=useState(null)

  const [users, setUsers] = useState(null)
  const [localUsers, setLocalUsers] = useState(users);
  const [popupUser,setPopupUser]=useState(null)
  const [newUser,setNewUser]=useState(null)

  const [pseudo, setPseudo] = useState([]);
  const [campus, setCampus] = useState([]);
  const [groupe, setGroupe] = useState([]);

  // Données exemple pour les options des filtres
  const [pseudosOptions,setPseudosOptions] = useState([])
  const [campusOptions,setCampusOptions] = useState([])
  const [groupesOptions,setGroupesOptions] = useState([])

  useEffect(()=>{
    if(users==null){
      clickActualiser()
    }
    setLocalUsers(users)
  },[users])


    const getUniqueValues = (data, attribute) => {
      /* console.log(values) */
      const values = data.map(item => {
       
        return item[attribute]; // Sinon, retourner la valeur normale de l'attribut
      });
    
      const uniqueValues = [...new Set(values)].sort(); 
      /* uniqueValues.unshift("Tous");  */
  /*     console.log(uniqueValues) */
      return uniqueValues;
    };

    const filterAndGroupList=(userList)=>{
      /* console.log(userList) */
      const groupedByUser = userList
       .filter((user) => (pseudo.length>0 ? pseudo.includes(user.pseudo): true))
       .filter((user) => (campus.length>0 ? campus.includes(user.campus): true))
       .filter((user) => (groupe.length>0 ? groupe.includes(user.groupe): true))
  
      /*   .reduce((acc, curr) => {
        const { idUser, bestScore } = curr;
    
        // Vérifier si l'utilisateur existe déjà dans l'accumulateur
        if (!acc[idUser]) {
            acc[idUser] = { ...curr, totalBestScore: bestScore };
        } else {
            acc[idUser].totalBestScore += bestScore;
        }
    
        return acc;
      }, {}); */
    
      // Convertir l'objet en tableau
      setLocalUsers( Object.values(groupedByUser));
      return Object.values(groupedByUser)
    }


    useEffect(()=>{
      if (users !== null && users.length>0) {
        const localUserList=filterAndGroupList(users)
        setLocalUsers( Object.values(localUserList));
      }
       
      },[pseudo,campus,groupe])
  
    useEffect(() => {
      if (users !== null && users.length>0) {
        setPseudosOptions(getUniqueValues(users,"pseudo"))
         setCampusOptions(getUniqueValues(users,"campus"))
        setGroupesOptions(getUniqueValues(users,"groupe")) 
        filterAndGroupList(users)
      }
    }, [users])
  

  const clickActualiser = async () => {
    // if (users == null){
    const users = await BackendAPI.getEtudiants()
    setUsers(users)
    // }
    // setActualiser(false)
   
  }
  
  const updateServer =async(event,field,id) => {
    event.preventDefault()
    console.log("etudiant update")
    var value="false"
    if(field!=="actif"){
      value=event.target.value
    }
    if(field=="email"){
      value=value.toLowerCase()
    }
    
     await BackendAPI.updateEtudiant(value,field,id)
    //  setUsers(null)
  }
  
  const handleClicNewUser=async()=>{
    await BackendAPI.createUser(newUser)
    setNewUser(null)
    clickActualiser()
  }

  const handleChangeUser = (event, field, id) => {
    // setActualiser(true)
    const newValue = event.target.value;

    // Crée une nouvelle liste d'utilisateurs avec les modifications apportées
    const updatedUsers = localUsers.map(user =>
      user.id === id
        ? { ...user, [field]: newValue }
        : user
    );

    // Met à jour l'état avec la nouvelle liste d'utilisateurs
    setLocalUsers(updatedUsers);
  };

  const handleChangeNewUser = (event, field) => {
    const newValue = event.target.value;
    const user = {
      ...newUser,
      [field]: field !== "email" ? newValue : newValue.toLowerCase()
    };
    setNewUser(user);
  };
  const handleKeyDown =  (event,field,id)=> {
    if (event.key === 'Enter') {
      event.preventDefault(); 
      updateServer(event,field,id);
    }
  };

  const handleBlur =  (event,field,id)=> {
    updateServer(event,field,id);
  };

  const handleClicDelete=(u)=>{
    const popupText= <Typography>
    Souhaitez-vous confirmer la suppression de l'utilisateur suivant ?
    <br />
    {u.nom} {u.prenom} - {u.email} - {u.campus} - {u.groupe}
</Typography>
    setPopupUser(u)
    setPopupText(popupText)
  }

  const renderChoices=(champ,u)=>{
    var val=""

    const mode_new=!(u!==null &&u.id!=undefined)



    if (champ=="Campus"){
      const campus=["Aix-En-Provence","Angers","Bordeaux","Budapest","Luxembourg","Lyon","Malaga","Paris","Shanghai","Strasbourg"]
      if(u!=null){val=u.campus}

      if(mode_new){
        return(
          <FormControl variant="outlined" style={{width:"100%"}}  >
          <InputLabel >{u!==null && u.id!=undefined?null:"Campus"}</InputLabel>

          <Select
          
            value={val}
            displayEmpty
            label={u!==null && u.id!=undefined?null:"Campus"}
            onChange={(e)=>{handleChangeNewUser(e,"campus")} }
            >
           
            {campus.map(c => (
            <MenuItem key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          </FormControl>  
        )
      
      }else{
        return(
          // <FormControl >
  
          
          <Select style={{width:"100%"}} 
            value={val}
            variant="outlined"
            onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e,"campus",u.id)}} }
            onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e,"campus",u.id)}} }
            >
           
            {campus.map(c => (
            <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          // </FormControl>
        ) 
      }
     
    }

    if (champ=="Groupe"){
      const groupes=["1A","2A","3A","4A","5A"]
      if(u!=null){val=u.groupe}

      if(mode_new){
        return(
          <FormControl variant="outlined" style={{width:"100%"}} >
          <InputLabel >{u!==null && u.id!=undefined?null:"Groupe"}</InputLabel>

          <Select
          
            value={val}
            displayEmpty
            label={u!==null && u.id!=undefined?null:"Groupe"}
            onChange={(e)=>{handleChangeNewUser(e,"groupe")} }
            >
           
            {groupes.map(c => (
            <MenuItem key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          </FormControl>  
        )
      
      }else{
        return(
          // <FormControl >
  
          
          <Select
            value={val}
            variant="outlined"
            onChange={(e)=>{if(u!==null &&u.id!=undefined){handleChangeUser(e,"groupe",u.id)}} }
            onBlur={(e)=>{if(u!==null &&u.id!=undefined){handleBlur(e,"groupe",u.id)}} }
            >
           
            {groupes.map(c => (
            <MenuItem style={{paddingTop:14}}key={c} value={c}  >{c}</MenuItem>
          ))}
          </Select>
          // </FormControl>
        ) 
      }
    }
  }

  const renderUsers = () => {
    if (localUsers !== null) {
      return (
        <TableContainer component={Paper} style={{ maxHeight: "100%" }} >
          <Table  stickyHeader aria-label="customized table">
            <TableHead>
              <TableRow >
                {/* <TableCell align="center">Id</TableCell> */}

                <TableCell align="center" style={{ width: 150 }}>Nom</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Prénom</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Email</TableCell>

                <TableCell align="center"  style={{ width: 150 }}>Pseudo</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Campus</TableCell>
                <TableCell align="center"  style={{ width: 150 }}>Groupe</TableCell>
                <TableCell align="center"  style={{ width: 50 }}>
                {/* <Button
          variant="contained"
          style={{padding:4}}
          className=""
          color={"primary"}
          disabled={!actualiser}
        >
          {"Actualiser"}
        </Button> */}

                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localUsers.map((u) => (
                <TableRow key={u.id} style={{height:10}}>
                  {/* <TableCell align="center">{u.id}</TableCell> */}
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  value={u.nom}
                  onChange={ (e)=>handleChangeUser(e,"nom",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
                  onBlur={ (e)=>handleBlur(e,"nom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center"style={{ width: 150 }}> <TextField
                  value={u.prenom}
                  onChange={ (e)=>handleChangeUser(e,"prenom",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
                  onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 300 }}> <TextField
                  value={u.email}
                  onChange={ (e)=>handleChangeUser(e,"email",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  onBlur={ (e)=>handleBlur(e,"email",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center"style={{ width: 150 }}> <TextField
                  value={u.pseudo}
                  onChange={ (e)=>handleChangeUser(e,"pseudo",u.id)}
                  onKeyDown={ (e)=>handleKeyDown(e,"pseudo",u.id)}
                  onBlur={ (e)=>handleBlur(e,"pseudo",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center"style={{ width: 150 }}>
                  {renderChoices("Campus",u)}
                </TableCell>

                <TableCell align="center">
                  {renderChoices("Groupe",u)}
                </TableCell>
                <TableCell align="center"  style={{ width: 50 }}>
                  <IconButton aria-label="delete" >
                    <DeleteIcon color="primary" onClick={(e)=>{
                      handleClicDelete(u)
                      // handleBlur(e,"actif",u.id)
                    }}/>
                  </IconButton>
                </TableCell>
                </TableRow>
              ))} 

              {renderNewUser()}     
            </TableBody>
          </Table>
        </TableContainer>)
    }

    return null

  }

  const renderNewUser = () => {

    var disabled = !newUser  || !newUser.nom || newUser.nom.length === 0 || !newUser.prenom || newUser.prenom.length === 0 || !newUser.email || newUser.email.length === 0 || !newUser.campus || newUser.campus.length === 0 || !newUser.groupe || newUser.groupe.length === 0 


      return (
         <TableRow key={"NEW USER"}>
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  label="Nom"
                  value={newUser!=null? newUser.nom : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"nom")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"nom",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"nom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  label="Prénom"
                  value={newUser!=null? newUser.prenom : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"prenom")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"prenom",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"prenom",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 300 }}> <TextField
                  placeholder="Email"
                  value={newUser!=null? newUser.email : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"email")}
                  // onKeyDown={ (e)=>handleKeyDown(e,"email",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"email",u.id)}
                  variant="outlined"
                  label="Email"
                  size="small"
                /></TableCell>
                  <TableCell align="center" style={{ width: 150 }}> <TextField
                  label="Pseudo"
                  value={newUser!=null? newUser.pseudo : ''}
                  onChange={ (e)=>handleChangeNewUser(e,"pseudo")}
                  // onChange={ (e)=>handleChangeUser(e,"pseudo",u.id)}
                  // onKeyDown={ (e)=>handleKeyDown(e,"pseudo",u.id)}
                  // onBlur={ (e)=>handleBlur(e,"pseudo",u.id)}
                  variant="outlined"
                  size="small"
                /></TableCell>
                <TableCell align="center" style={{ width: 150 }}> 
                  {renderChoices("Campus",newUser)}
                </TableCell>

                <TableCell align="center" style={{ width: 150 }}>
                  {renderChoices("Groupe",newUser)}
                </TableCell>
                <TableCell align="center" style={{ width: 50 }}>
                  <IconButton aria-label="ajouter"  disabled={disabled}>
                    <AddIcon  
                       color={disabled ?"default":"secondary"}
                      //  || !newUser.nom || newUser.nom.length === 0
                      
                      onClick={(e)=>{
                        handleClicNewUser()
                      // handleClicDelete(u)
                      // handleBlur(e,"actif",u.id)
                    }}/>
                  </IconButton>
                </TableCell>
                </TableRow> )
    }


  const handleClosePopup=async(choix)=>{
    
    switch (choix) {
      case 'Supprimer Utilisateur':
        console.log(popupUser.id)
        // setActualiser(true)
        await BackendAPI.updateEtudiant("false","actif",popupUser.id)
        setPopupUser(null)
        setUsers(null)
    }

    setPopupText(null)
  }


  

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div 
      className="body-admin"
    >
      <Typography variant="h1" color="primary">Gestion des étudiants</Typography>
      <Divider />
      {
        popupText!=null ?
        <Popup open={true} text={popupText} reponse={"Supprimer Utilisateur"} handleClose={handleClosePopup} ></Popup>
        :
        null
      }
             <div style={{margin:10}}  >
             <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
<FormControl size="small" variant="outlined">
              <InputLabel>Pseudos</InputLabel>

             

              <Select
                multiple
                value={pseudo}
                onChange={(event) => setPseudo(event.target.value)}
                label="Pseudos"
                renderValue={(selected) => selected.join(', ')}

              >

                {pseudosOptions.map((option) => (
                   <MenuItem key={option} value={option}>
                   <Checkbox checked={pseudo.indexOf(option) > -1} />
                   <ListItemText primary={option} />
                 </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Liste déroulante pour le Campus */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Campus</InputLabel>

              <Select
                multiple
                value={campus}
                onChange={(event) => setCampus(event.target.value)}
                label="Campus"
                renderValue={(selected) => selected.join(', ')}

              >

                {campusOptions.map((option) => (
                   <MenuItem key={option} value={option}>
                   <Checkbox checked={campus.indexOf(option) > -1} />
                   <ListItemText primary={option} />
                 </MenuItem>
                ))}
              </Select>

            </FormControl>

            {/* Liste déroulante pour le Groupe */}
            <FormControl size="small" variant="outlined">
              <InputLabel>Groupes</InputLabel>
              <Select
                multiple
                value={groupe}
                onChange={(event) => setGroupe(event.target.value)}
                label="Groupes"
                renderValue={(selected) => selected.join(', ')}

              >

                {groupesOptions.map((option) => (
                   <MenuItem key={option} value={option}>
                   <Checkbox checked={groupe.indexOf(option) > -1} />
                   <ListItemText primary={option} />
                 </MenuItem>
                ))}
              </Select>

             
            </FormControl>
          </div>

{/*           <Typography variant="h5" color="primary">Liste d'étudiants</Typography>
 */}          <br></br>

          {renderUsers()}

        {/*   <br></br>
          <Typography variant="h5" color="primary">Créer un nouvel étudiant</Typography>

          {renderNewUser()} */}
          {/* {newUser.nom} {newUser.prenom} {newUser.email} ({newUser.campus} - {newUser.groupe}) */}
        </div>
            


      {/* </div> */}

    </div></div>
  );
}

export default AdminEtudiants;

